import { IS_DEV } from "../components/utils";

const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;
const DATA_IMAGE_URI_REGEX = /^data:image\/[a-zA-Z0-9.+-]+;base64,/;
export const SUPPORTED_LANGUAGES = ["en", "es", "fr", "pt"];
const MAX_RAW_THEME_LENGTH = 2048;
const HEX_COLOR_FIELDS = ["primaryColor", "backgroundColor", "titleColor", "subtitleColor", "bodyColor"];

/**
 * Strips out anything that isn't a well-formed theme field. Used for every
 * untrusted source of theme data (query param today, postMessage override
 * later) so there's one place that decides what's safe to apply — an invalid
 * or missing field is dropped, not defaulted to a placeholder, so callers can
 * fall through to the next precedence layer.
 */
export function validateTheme(raw) {
  if (!raw || typeof raw !== "object") return {};

  const result = {};
  HEX_COLOR_FIELDS.forEach((field) => {
    if (typeof raw[field] === "string" && HEX_COLOR_REGEX.test(raw[field])) {
      result[field] = raw[field];
    }
  });
  // Customer-supplied, rendered into an <img src> — only accept https (or
  // http in local dev, mirroring parseAllowedParentOrigin's convention), or
  // a base64 data:image/* URI (used by the dashboard's branding preview,
  // which fetches the logo through its own authenticated proxy and inlines
  // it since this app's origin can't authenticate against that proxy
  // itself). Never a bare "data:" — restricting to the image/* MIME subtype
  // with an explicit base64 marker rules out a data:text/html;base64,...
  // payload while still blocking javascript:/other unsafe schemes.
  if (
    typeof raw.logoUrl === "string" &&
    (raw.logoUrl.startsWith("https://") ||
      (IS_DEV && raw.logoUrl.startsWith("http://")) ||
      DATA_IMAGE_URI_REGEX.test(raw.logoUrl))
  ) {
    result.logoUrl = raw.logoUrl;
  }
  if (typeof raw.language === "string" && SUPPORTED_LANGUAGES.includes(raw.language)) {
    result.language = raw.language;
  }
  return result;
}

/**
 * Parses the `theme` query param — same length-cap / silent-empty-on-failure
 * convention already used for `metadata` in Home.jsx.
 */
export function parseThemeQueryParam(raw) {
  if (raw == null) return {};
  if (raw.length > MAX_RAW_THEME_LENGTH) return {};
  try {
    return validateTheme(JSON.parse(raw));
  } catch {
    return {};
  }
}
